define(function(require) {
    return {
        LAYER_ID : "DRAWING_LAYER",
        LAYER_TYPE : "DRAWING",
        LOADING_MODE : "MANUAL",
        DATATABLE_ID : "AttributesDataTable_drawingLayer", //must not be modified
        INDEX : 47,
        FIELDS : [
            {ID : "Id", NAME : "ID", DATA_TYPE : "STRING", VALUE : "{{GUID}}"}, //colonne Id obligatoire
            {ID : "Description", NAME : "Nom", DATA_TYPE: "STRING", VALUE : "{{DESCRIPTION}}"}, //colonne Description obligatoire
            {ID : "SCENARIO", NAME : "Scénario", DATA_TYPE: "STRING", VALUE : "{{SCENARIO}}"}
        ],
        LAYER_PROPERTIES : {
            NAME : "Limites et annotations",
            FEATURE_ID_DATACOLUMN : "Id",
            DATATIP_DATACOLUMNS : ["Description"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : [],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["Description"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            LABEL_DATACOLUMN : "Description",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : true,
                LEADER_LINES : false,
                POSITION : "AUTO-PLACEMENT",
                PRIORITY : 1,
                VISIBLE : true
            },
            IS_VISIBLE_IN_LEGEND : false,
            UNIQUE_FEATURES_STYLES : true
        },
        ANNOTATIONS : {
            LAYER_ID : "GEO07E14_ANNOTATIONS_SPES",
            LAYER_TYPE : "ANNOTATION",
            LOADING_MODE : "INITIAL",
            TOKEN_REQUIRED: true,
            QUERY_FIELDS : [
                "GUID", "ANCHOR_X", "ANCHOR_Y", "TEXT_POSITION_X", "TEXT_POSITION_Y", "MAP_SCALE", "ROTATION", "TEXT", "TEXT_COLOR",
                "TEXT_SIZE", "BOLD", "ITALIC", "UNDERLINED", "HAS_HALO", "HALO_COLOR", "FILL_STYLE", "FILL_COLOR",
                "STROKE_STYLE", "STROKE_COLOR", "STROKE_WIDTH", "SCENARIO", "DESCRIPTION"
            ],
            STYLES : [
                {
                    ID : "s_{{GUID}}",
                    SYMBOLIZERS : [
                        {
                            SYMBOLIZER_TYPE : "AnnotationSymbolizer",
                            BOLD : "{{BOLD}}",
                            COLOR : "{{TEXT_COLOR}}",
                            FILL_COLOR_1 : "{{FILL_COLOR}}",
                            FILL_STYLE : "{{FILL_STYLE}}",
                            HALO_COLOR : "{{HALO_COLOR}}",
                            HAS_HALO : "{{HAS_HALO}}",
                            ITALIC : "{{ITALIC}}",
                            SIZE : "{{TEXT_SIZE}}",
                            STROKE_COLOR : "{{STROKE_COLOR}}",
                            STROKE_STYLE : "{{STROKE_STYLE}}",
                            STROKE_WIDTH : "{{STROKE_WIDTH}}",
                            UNDERLINED : "{{UNDERLINED}}"
                        }
                    ]
                }
            ]
        },
        LINES : {
            LAYER_ID : "GEO07E13_LINES_SPES",
            LAYER_TYPE : "POLYLINE",
            LOADING_MODE : "INITIAL",
            TOKEN_REQUIRED: true,
            QUERY_FIELDS : ["GUID", "STROKE_STYLE", "STROKE_COLOR", "STROKE_PATTERN", "STROKE_WIDTH", "SCENARIO", "DESCRIPTION"],
            STYLES : [
                {
                    ID : "s_{{GUID}}",
                    SYMBOLIZERS : [
                        {
                            SYMBOLIZER_TYPE : "PolylineSymbolizer",
                            STROKE_COLOR : "{{STROKE_COLOR}}",
                            STROKE_WIDTH : "{{STROKE_WIDTH}}",
                            STROKE_PATTERN : "{{STROKE_PATTERN}}",
                            STROKE_STYLE : "{{STROKE_STYLE}}"
                        }
                    ]
                }
            ]
        },
        STYLES : []
    };
});
